//bao migrate skip
import "./../../interfaces/ipage";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../services/bao-router";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import tabPage from "./../../factories/tab-page";
import baoRouter from "./../../services/bao-router";
class DailyShiftPlanOverviewDialog {
    Dialog: BaoDialog;
    TabPage: tabPage;
    Table: HTMLElement;
    DialogHTML: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    CellOverlay: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    Years: KnockoutObservableArray<string> = ko.observableArray([]);
    SelectedYear: KnockoutObservable<string> = ko.observable();
    SelectedMonth: KnockoutObservable<string> = ko.observable();
    Calendar: KnockoutObservableArray<any> = ko.observableArray([]);
    ShiftTypeCollection: KnockoutObservableArray<any> = ko.observableArray([]);
    SelectedDailyPlan: KnockoutObservable<any> = ko.observable();
    ShiftbookId: KnockoutObservable<string> = ko.observable();
    ShiftBookName: KnockoutObservable<string> = ko.observable();
    IsFirstLoaded: KnockoutObservable<boolean> = ko.observable(false);
    SidebarLeft: KnockoutObservable<string> = ko.observable('0');
    HeaderTop: KnockoutObservable<string> = ko.observable('0');
    constructor(dialog: BaoDialog, tabPage: tabPage, date: string, shiftbookId: string, shiftbookName: string) {
        this.Dialog = dialog;
        this.TabPage = tabPage;
        this.init(date);
        this.ShiftbookId(shiftbookId);
        this.ShiftBookName(shiftbookName);
        this.SelectedYear.subscribe(() => {
            this.loadDailyPlanOverview();
        });
        this.SelectedMonth.subscribe(() => {
            this.loadDailyPlanOverview();
        });
    }
    init = (date: string) => {
        this.TabPage.IsLoading(true);
        return Bao.post("ShiftSchedule/DailyPlanOverviewDialogMetaData")
            .done((result: {
            Years: Models.HashObject[];
        }) => {
            for (var r in result.Years) {
                if (result.Years[r].Key && result.Years[r].Value) {
                    this.Years.push(result.Years[r].Key);
                }
            }
            this.SelectedYear(date.substring(0, 4));
            this.SelectedMonth(date.substring(4, 6));
        });
    };
    loadDailyPlanOverview = () => {
        this.unselectCell();
        if (this.SelectedYear() && this.SelectedMonth() && this.SelectedMonth() !== "0") {
            this.TabPage.IsLoading(true);
            return Bao.post("ShiftSchedule/DailyPlanOverviewDialogData", JSON.stringify({
                year: this.SelectedYear(),
                month: this.SelectedMonth(),
                shiftbookId: this.ShiftbookId()
            })).done((result: {
                Calendar: any[];
                ShiftTypeCollection: any[];
            }) => {
                this.Calendar(result.Calendar);
                this.ShiftTypeCollection(result.ShiftTypeCollection);
                if (!this.Table) {
                    this.setTableListeners();
                }
                this.recalcOverviewPosition();
                this.recalcScroll();
                this.IsFirstLoaded(true);
                this.TabPage.IsLoading(false);
            });
        }
    };
    ClickOnCell(data: any, event: {
        target: HTMLElement;
    }) {
        if (this.SelectedDailyPlan() === data) {
            this.unselectCell();
        }
        else {
            this.selectCell(data, event.target);
        }
    }
    ClickEditDailyPlan = () => {
        if (this.SelectedDailyPlan()) {
            this.beforeClose();
            this.Dialog.Close();
            this.Dialog.DialogResult(this.SelectedDailyPlan());
        }
    };
    private unselectCell = () => {
        this.SelectedDailyPlan(null);
        $(this.CellOverlay()).hide();
    };
    private selectCell = (data: any, target: HTMLElement) => {
        this.SelectedDailyPlan(data);
        this.createOverlay(target);
    };
    private createOverlay = (target: HTMLElement) => {
        if (target !== null) {
            let cellOverlayRect = target.getBoundingClientRect();
            let overlayContainerRect = $(this.DialogHTML()).find(".overlay-container").get(0).getBoundingClientRect();
            $(this.CellOverlay()).css("top", cellOverlayRect.top - overlayContainerRect.top)
                .css("left", cellOverlayRect.left - overlayContainerRect.left)
                .width(cellOverlayRect.width - 2)
                .height(cellOverlayRect.height - 2)
                .show();
        }
    };
    private setTableListeners = () => {
        this.Table = $(this.DialogHTML()).find(".daily-plan-table").get(0);
        this.Table.addEventListener("resize", this.resizeEventHandler);
        this.Table.addEventListener("scroll", this.scrollEventHandler);
    };
    private scrollEventHandler = (e) => {
        e.preventDefault();
        this.recalcScroll();
        this.unselectCell();
    };
    private resizeEventHandler = (e) => {
        this.recalcOverviewPosition();
    };
    private recalcScroll = () => {
        this.SidebarLeft(this.Table.scrollLeft + "px");
        this.HeaderTop(this.Table.scrollTop + "px");
    };
    private recalcOverviewPosition = () => {
        let dialogContainer = $(this.DialogHTML());
        let filtersHeight = dialogContainer.find(".filters").height();
        this.Table.style.top = filtersHeight + "px";
        this.Table.style.maxHeight = dialogContainer.height() - filtersHeight + "px";
    };
    private beforeClose = () => {
        this.Table.removeEventListener("resize", this.resizeEventHandler);
        this.Table.removeEventListener("scroll", this.scrollEventHandler);
    };
}
export default DailyShiftPlanOverviewDialog;